import { StoreProductGroupId } from "../store/identifiers";
import { Schema as S } from "effect";
export class Schema extends S.Class("@open-revenue/S/store/ProductGroup")({
    object: S.Literal("or_store_product_group").pipe(S.propertySignature, S.withConstructorDefault(()=>"or_store_product_group")),
    id: StoreProductGroupId.Schema,
    name: S.String,
    description: S.String.pipe(S.NullOr),
    active: S.Boolean
}) {
}
